import type { IconName } from '@renderer/shared/components/icons';

export interface NavigationItem {
  id: string;
  path: string;
  labelKey: string;
  icon: IconName;
  kind: 'primary' | 'secondary';
}

export const navigationItems: NavigationItem[] = [
  { id: 'dashboard', path: '/dashboard', labelKey: 'navigation.dashboard', icon: 'dashboard', kind: 'primary' },
  { id: 'projects', path: '/projects', labelKey: 'navigation.projects', icon: 'projects', kind: 'primary' },
  { id: 'leads', path: '/leads', labelKey: 'navigation.leads', icon: 'leads', kind: 'primary' },
  { id: 'tasks', path: '/tasks', labelKey: 'navigation.tasks', icon: 'tasks', kind: 'primary' },
  { id: 'customers', path: '/customers', labelKey: 'navigation.customers', icon: 'customers', kind: 'primary' },
  { id: 'resources', path: '/resources', labelKey: 'navigation.resources', icon: 'resources', kind: 'primary' },
  { id: 'contracts', path: '/contracts', labelKey: 'navigation.contracts', icon: 'contracts', kind: 'primary' },
  { id: 'invoices', path: '/invoices', labelKey: 'navigation.invoices', icon: 'invoices', kind: 'primary' },
  { id: 'payments', path: '/payments', labelKey: 'navigation.payments', icon: 'payments', kind: 'primary' },
  { id: 'avi', path: '/avi', labelKey: 'navigation.avi', icon: 'avi', kind: 'secondary' },
  { id: 'settings', path: '/settings', labelKey: 'navigation.settings', icon: 'settings', kind: 'secondary' },
  { id: 'help', path: '/help', labelKey: 'navigation.help', icon: 'help', kind: 'secondary' }
];
